import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "tc_install_dismissed";

const esIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);
const esStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [mostrarIos, setMostrarIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1" || esStandalone()) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    if (esIos()) {
      setMostrarIos(true);
      setVisible(true);
    }

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const descartar = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const instalar = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    descartar();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt-banner"
      className="fixed inset-x-0 bottom-0 z-[150] mx-auto flex max-w-md items-center gap-3 border-t border-[var(--tc-border)] bg-white p-4 shadow-[0_-4px_16px_rgb(15_23_42_/_0.08)] tc-fade-up sm:bottom-4 sm:left-4 sm:right-auto sm:rounded-[var(--tc-radius)] sm:border"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[var(--tc-radius)] bg-[var(--tc-accent-soft)] text-[var(--tc-accent)]">
        {mostrarIos ? <Share size={18} /> : <Download size={18} />}
      </span>
      <div className="flex-1 text-sm">
        <p className="font-medium text-[var(--tc-text)]">Instalá Torre de Control</p>
        <p className="mt-0.5 text-xs leading-relaxed text-[var(--tc-text-secondary)]">
          {mostrarIos
            ? 'Tocá Compartir y luego "Agregar a inicio".'
            : "Accedé más rápido, incluso con mala conexión."}
        </p>
      </div>
      {!mostrarIos && (
        <button
          data-testid="install-prompt-accept"
          onClick={instalar}
          className="shrink-0 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-3 py-2 text-xs font-semibold text-white transition-colors duration-150 hover:bg-[var(--tc-accent-hover)]"
        >
          Instalar
        </button>
      )}
      <button
        data-testid="install-prompt-dismiss"
        onClick={descartar}
        aria-label="Cerrar aviso de instalación"
        className="shrink-0 text-[var(--tc-text-secondary)] transition-colors duration-150 hover:text-[var(--tc-text)]"
      >
        <X size={16} />
      </button>
    </div>
  );
};
